
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrafficCriteriaFilters"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traffic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"first"},"name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spam"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"first"},"name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countLeadsCreated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsIntegrated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsNew"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countCallAttempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countRecalls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageCallTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsWasInRecall"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsAccepted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conversionApprove"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsCancelled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsValidCancelReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsInvalidCancelReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsDouble"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsSpamByAdvertiser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countNegativeCallBackLeads"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countLeadsLzHold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countValidCalls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageCallAttemptsByTotalAttempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageCallsByTotalAttempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageCallAttempts"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":957}};
    doc.loc.source = {"body":"# noinspection GraphQLUnresolvedReference\nquery ($filters: TrafficCriteriaFilters) {\n    traffic (filters: $filters) {\n        cancel {\n            reason\n            first: count\n        }\n        spam {\n            reason\n            first: count\n        }\n        total {\n            countLeadsCreated\n            countLeadsIntegrated\n            countLeadsNew\n            countCallAttempts\n            countRecalls\n            averageCallTime\n            countLeadsWasInRecall\n            countLeadsAccepted\n            conversionApprove\n            countLeadsCancelled\n            countLeadsValidCancelReason\n            countLeadsInvalidCancelReason\n            countLeadsDouble\n            countLeadsSpamByAdvertiser\n            countNegativeCallBackLeads\n            countLeadsLzHold\n            countValidCalls\n            averageCallAttemptsByTotalAttempts\n            averageCallsByTotalAttempts\n            averageCallAttempts\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
